<script>
export default {
  name: 'CreditCardBox',
  props: ['cardNumber', 'cardBrand'],
};
</script>

<template>
  <div class="credit-box">
    <img v-if="cardBrand === 'link'" src="../../assets/imgs/link-icon.png" alt="Credit Card" />
    <img v-else src="../../assets/imgs/xinyongqia.png" alt="Credit Card" />
    <div class="credit-card">
      <p class="number">{{ cardBrand === 'link' ? '' : '•••• ' }}{{ cardNumber }}</p>
      <p class="desc">Order fees will be deducted from the method</p>
    </div>
  </div>
</template>

<style scoped lang="less">
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.credit-box {
  width: 498px;
  padding: 30px;
  margin-top: 20px;
  border-radius: 4px;
  border: 1px solid #eeeff0;
  display: flex;
  flex-direction: row;
  img {
    width: 40px;
    height: 40px;
  }
  .credit-card {
    padding-left: 46px;
    .number {
      .font-regular;
      height: 22px;
      font-size: 18px;
      font-weight: 400;
      color: #262626;
      line-height: 22px;
    }
    .desc {
      .font-light;
      height: 15px;
      font-size: 12px;
      font-weight: 300;
      color: #afb5c6;
      line-height: 15px;
      padding-top: 10px;
    }
  }
}
</style>
